<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>

            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('sidebars.journal') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">

                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_data_all()"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>

          <CRow>


            <CCol col="3">
              <date-picker
                  :label="$t('components.startDate')"
                  v-model="start_date"></date-picker>
            </CCol>
            <CCol col="3">
              <date-picker
                  :label="$t('components.endDate')"
                  v-model="end_date"></date-picker>
            </CCol>
            <CCol col="1">
              <CButton @click="load_data" color="dark"
                       size="sm">
                <CIcon size="sm" name="cil-zoom"/>
              </CButton>
            </CCol>
          </CRow>
          <CRow>

            <CRow v-show="false">
              <CCol>
                <CSelect
                    :label="$t('components.province')"

                    :options="province_items"
                    :value.sync="selected_province"/>

              </CCol>
              <CCol>
                <CSelect
                    :label="$t('components.city')"

                    :options="city_items"
                    :value.sync="selected_city"/>

              </CCol>
              <CCol>
                <CSelect
                    :label="$t('town')"

                    :options="district_items"
                    :value.sync="selected_district"/>
              </CCol>
              <CCol>
                <CSelect
                    :label="$t('components.area')"

                    :options="area_items"
                    :value.sync="selected_area"/>

              </CCol>

              <CCol>
                <CSelect
                    :label="$t('route')"
                    :options="route_items"
                    :value.sync="selected_route"/>
              </CCol>
              <CCol>
                <CSelect
                    :label="$t('country')"
                    :value.sync="selected_country"
                    :options="country_items"
                />
              </CCol>

            </CRow>

          </CRow>
          <CCardBody :id="body_id">
            <CDataTableFixed
                :items="items_customer_all"
                :fields="fields_all"
                @row-clicked="table_row_clicked"
                sorter
                height="300px"
                :column-filter="get_filter_table"
                hover
                border
                striped
            >
              <template #row_id="{item,index}">

                <td>
                  <p style="text-align: center">{{ index+1 }}</p>

                </td>

              </template>

              <template #docMasterCode="{item,index}">
                <td>
                  <p style="text-align: center">{{ item.docMasterCode }}</p>
                </td>
              </template>

              <template #amount="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.amount) }}</p>
                </td>
              </template>
              <template #docDate="{item}">
                <td>
                  <p style="text-align: center">{{ get_date(item.docDate) }}</p>
                </td>
              </template>
              <template #creditor="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(Math.abs(item.creditor)) }}</p>
                </td>
              </template>

              <template #masterId="{item}">
                <td>
                  <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                    {{ item.masterId }}
                    <CIcon name="cil-speedometer"/>
                  </a>

                </td>

              </template>

              <template #summary="{item}">
                <td>
                  <p >
                    <span>{{ item.docTypeTitle }} </span>
                    <span v-if="item.summary != 'null'"> {{ item.summary }}</span>
                   </p>
                </td>

              </template>


              <template #debtor="{item}">
                <td>
                  <p class="text-right">{{ get_currency(item.debtor) }}</p>
                </td>
              </template>

    <template #caption>
                <tr class="total-table">

                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ $t('totalCirculation') }}</td>
                  <td :style="get_style_diff(get_sum_debtor(items_customer_all, 'debtor'),Math.abs(get_sum_credetor(items_customer_all, 'creditor')))">
                    {{ get_currency(get_sum_debtor(items_customer_all, 'debtor')) }}</td>
                  <td :style="get_style_diff(get_sum_debtor(items_customer_all, 'debtor'),Math.abs(get_sum_credetor(items_customer_all, 'creditor')))">

                  {{ get_currency(Math.abs(get_sum_credetor(items_customer_all, 'creditor'))) }}</td>

                </tr>

              </template>
            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;margin-bottom: 30px">
      <CCol>
        <CRow style="justify-content:center">
          <strong style="font-size: large">{{ get_bussiness_name() }}</strong>
        </CRow>

        <CRow style="justify-content:center">
          <strong>{{ $t('sidebars.journal') }} {{get_year(start_date)}}</strong>
        </CRow>
        <CRow>
          <CCol>
            <label>{{ $t('FromDate') }} {{ get_date(start_date) }}</label>
          </CCol>
          <CCol style="text-align:center">
            <label>{{ $t('UpToDate') }} {{ get_date(end_date) }}</label>
          </CCol>
          <CCol style="text-align:end">
            <label>{{ $t('PreparedDate') }} {{ get_date(get_today()) }}</label>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <label v-if="selected_city!=0">{{ city_items.filter(x => x.cityId == selected_city)[0].cityName }} ,</label>
            <label v-if="selected_district!=0">{{ district_items.filter(x => x.id == selected_district)[0].title }}
              ,</label>
            <label v-if="selected_route!=0">{{ route_items.filter(x => x.id == selected_route)[0].title }}</label>
          </CCol>
        </CRow>
      </CCol>

    </div>
    <div v-show="false" :id="footer_id">
      <CCardHeader>
        <CRow style="border: 1px solid #424242">


          <CCol sm="4" md="4" style="text-align: start">
            <h6>{{ $t('docCreator') }} : {{ get_user_name() }}</h6>
          </CCol>
          <CCol sm="4" md="4" style="text-align: center">
            <h2 id="pageFooter" class="pageFooter"></h2>
          </CCol>
          <CCol sm="4" md="4" style="text-align: end">
            <h2>
            </h2>
          </CCol>
        </CRow>

      </CCardHeader>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
export default {
  name: 'AccountingJournal',
  components: {
    Treeselect,

  },
  data() {
    return {
      header_id: "header_accounting_journal" + new Date().getTime() + this.$vnode.tag,
      footer_id: "footer_accounting_journal" + new Date().getTime() + this.$vnode.tag,
      body_id: "body_accounting_journal" + new Date().getTime() + this.$vnode.tag,

      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      items_customer: [],
      items_customer_all: [],
      start_date: '',

      types_all: [],
      types_parent: [],
      selected_type_parent: 0,
      selected_type_child: 0,
      selected_status: 0,
      end_date: '',
      fields_all: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'docMasterCode', label: this.$t('docNumber'), _style: 'width:10%'},

        {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},

        // {key: 'reminingBefore', label: this.$t('balanceBefore'), _style: 'width:10%'},
        {key: 'debtor', label: this.$t('tables.debtor'), _style: 'width:10%'},
        {key: 'creditor', label: this.$t('tables.creditor'), _style: 'width:10%'},
      ],


      selected_person_name: '',

      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', true);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.fullName + " " + node.personCode,
        }
      },
      templates_items: [],
      accounting_list: [],
      moein_list: [],
      tafsili_list: [],
      selected_person: null,
      selected_moein: null,
      selected_tafsili: null,
      collapseDuration: 0,
      person_name: '',
      status_form: 0,

      route_items: [],
      selected_route: 0,

      area_items: [],
      selected_area: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,

      country_items: [],
      selected_country: 0,
      table_clicks: 0,
      table_clicks_timer: null,
      checkbox_all_items: [],
      check_all_exit: false,
      person_async_list: [],
      sync_person: true,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_country()
    this.get_routes()

    // this.get_lists();
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.load_data()

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.items_customer_all.forEach(function (val) {
          this.checkbox_all_items.push(val.personId);
        });

      } else {
        this.checkbox_all_items = [];
      }
    },

    'selected_province': function () {
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    },
    'selected_country': function () {
      this.get_provinces();
    },
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goShowDocument(item)
        this.table_clicks = 0

      }

    },
    goShowDocument(item) {

      // this.$router.push({path: '/dashboard/accounting/show-accounting-doc/' + item.id});
      window.open('/dashboard/accounting/show-accounting-doc/' + item.docMasterId)
    },
    get_style_diff(item1 , item2){
      var color = '#ff1403';
      if(parseFloat(item1).toFixed(2)!=parseFloat(item2).toFixed(2)){
        return 'color:#ff1403;'
      }else{
        return ' '
      }
    },
    print_data_all() {
      var self = this;
      this.fields_all.forEach(function (val, index) {
        if (val.key == "checkbox") {
          self.fields_all.splice(index, 1);
        }
      });
      this.print_with_header_title_height(this.body_id, this.header_id, this.footer_id, this.$t('customerBill'), 100, 100)

      setTimeout(function () {
        self.fields_all.push("{key: 'checkbox', label: \"\", _style: 'width:10%'}")
      }, 1000);

    },
    select_user(node, instance) {
      this.selected_person_name = node.fullName + " " + node.personCode;

    },


    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];

          self.country_items = self.sort_array(
              self.country_items, content_data.data,
              'id', 'title');

          if (self.$i18n.locale == 'fa') {
            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
          }
          if (self.$i18n.locale == 'en') {
            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items = [];
          self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});

          self.province_items = self.sort_array(
              self.province_items, content_data.data,
              'id', 'provinceName');


          self.selected_province = self.province_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items = []
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId', 'cityName');

          self.selected_city = self.city_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = []
          self.district_items = self.sort_array(
              self.district_items, content_data.data,
              'id', 'title');

          self.selected_district = self.district_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_areas() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_district);

      axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.area_items = []
          self.area_items = self.sort_array(
              self.area_items, content_data.data,
              'id', 'areaName');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.areaName, value: val.id}
          //
          //   self.area_items.push(obj);
          // });
          self.selected_area = self.area_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_routes() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = [{label: self.$t('all'), value: 0}]
          self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
          self.selected_route = self.route_items[0].value;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_style(item) {
      var color = '#56ff42';
      if (item.personAccountId == 0) {
        // return 'backgroundColor: \'#56ff42\'';
        return {

          backgroundColor: color

        }
      }

    },
    get_sum_debtor(list, field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');
        sum += parseFloat(val[field]);
      })
      return sum;
    },
    get_sum_credetor(list, field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');

        sum += parseFloat(val[field]);
      })
      return sum;
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    load_data() {
      this.get_lists_all_person();
    },
    get_lists_all_person() {
      var self = this;

      self.items_customer_all;
      const formData = new FormData();

      var url = "GetAccountDocByDocRptByDate";

      // formData.append('id', this.selected_person);
      formData.append('PartyType', 1);
      formData.append('CityId', this.selected_city);
      formData.append('ProvinceId', this.selected_province);
      formData.append('RegionId', this.selected_district);
      formData.append('AreaId', this.selected_area);
      formData.append('RouteId', this.selected_route);
      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer_all= []
          var first_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });
          first_items.forEach(function (val) {
            val.details.forEach(function (detail) {
              detail.row_id = val.row_id;
              detail.docDate = val.docDate;
              detail.docMasterCode = val.docMasterCode;
              detail.docType = val.docType;
              detail.docTypeTitle = val.docTypeTitle;
              detail.refrenceCode = val.refrenceCode;
              detail.summary = val.summary;
              self.items_customer_all.push(detail);

            })

          })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_child_options() {
      var array = [{label: this.$t('select'), value: 0}];
      var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
      return newArray
    }

  }
}

</script>
